var _linearGradient, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCloud1 = function SvgCloud1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cloud-1_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: -911.234,
    y1: 565.796,
    x2: -910.829,
    y2: 565.391,
    gradientTransform: "matrix(64 0 0 -64 58339 36231)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#517df8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cloud-1_svg__a)",
    d: "M57 66H9c-4.962 0-9-4.037-9-9V9c0-4.962 4.038-9 9-9h48c4.963 0 9 4.038 9 9v48c0 4.963-4.037 9-9 9zM9 2C5.14 2 2 5.14 2 9v48c0 3.859 3.14 7 7 7h48c3.859 0 7-3.141 7-7V9c0-3.86-3.141-7-7-7H9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0C13",
    d: "M42.821 44.211H22.625c-3.653 0-6.625-3.015-6.625-6.721 0-2.102 1.084-4.24 2.829-5.582 1.453-1.117 3.128-1.52 4.733-1.142.529-5.031 4.599-8.766 9.484-8.766 3.85 0 7.41 2.515 8.861 6.258l.329.849-.692.346a7.89 7.89 0 01.735-.092h.004c4.164-.298 7.717 3.15 7.717 7.462 0 4.073-3.221 7.388-7.179 7.388zM22.392 32.639c-.817 0-1.614.294-2.344.855C18.804 34.451 18 36.02 18 37.49c0 2.603 2.075 4.721 4.625 4.721h20.196c2.855 0 5.179-2.417 5.179-5.388 0-3.023-2.323-5.482-5.179-5.482-.354 0-.709.036-1.058.106l-.877.177-.078-.246a1.975 1.975 0 01-1.358-1.885c0-.402.12-.786.334-1.107C38.504 25.738 35.87 24 33.046 24c-3.85 0-7.061 2.955-7.485 6.88a1.964 1.964 0 01-.709 1.436 1.926 1.926 0 01-1.566.44 3.541 3.541 0 00-.894-.117z"
  })));
};
export default SvgCloud1;